import { LocationDto } from "src/dtos/location/locationDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";

export interface WMS2021_R01Dto extends WmsStockLotDto {

	groupKey: string;
	modelNo: string;
	oldWarehouseCd: string;
	logicCenter: string;
	oldLogicCenter: string;
	logicCenterNm: string;
	movedLotQty: number;
	locationCd?: string;
	locationNm?: string;

}

export const defaultWMS2021_R01Dto: WMS2021_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',
	
	groupKey: '',
	modelNo: '',
	oldWarehouseCd: '',
	logicCenter: '',
	oldLogicCenter: '',
	logicCenterNm: '',
	movedLotQty: 0,
	locationCd: '',
	locationNm: '',
	
	inserted: false,
	isModified: false,
}
